import styled, { css } from "styled-components";

export const Count = styled.div`
  ${({ theme }) => css`
    color: ${theme?.colour?.secondary ?? "#9EACB0"};
    font-weight: 400;
    font-size: 14px;
    margin-left: 2px;
  `}
`;